import type { SvgIconProps } from '@lokalise/louis';
import { SvgIcon } from '@lokalise/louis';

const ThumbUp = ({ ...props }: SvgIconProps) => (
    <SvgIcon {...props}>
        <path d="M4 8V20H0.5V8H4ZM6.86253 20C6.36855 20 5.89481 19.7893 5.54552 19.4142C5.19623 19.0391 5 18.5304 5 18V8C5 7.45 5.20488 6.95 5.54945 6.59L12.2769 0L13.2641 1.06C13.5155 1.33 13.6738 1.7 13.6738 2.11L13.6459 2.43L12.7612 7H18.6375C19.6712 7 20.5 7.9 20.5 9V11C20.5 11.26 20.4534 11.5 20.3696 11.73L17.5572 18.78C17.2778 19.5 16.6166 20 15.8437 20H6.86253ZM6.86253 18H15.8716L18.6375 11V9H10.4517L11.504 3.68L6.86253 8.03V18Z" />
    </SvgIcon>
);

export default ThumbUp;
